const editDetails = () => {
  const $editDetails = document.querySelector(".js-edit-details");
  if (!$editDetails) return;

  const classNames = ["hidden"];

  const $editDetailsButtons = [
    ...document.querySelectorAll(".js-edit-details-button")
  ];

  $editDetailsButtons.forEach($button => {
    $button.addEventListener("click", e => {
      e.preventDefault();
      classNames.forEach(className => {
        $editDetails.classList.toggle(className);
        $editDetails.setAttribute(
          "aria-hidden",
          !$editDetails.getAttribute("aria-hidden")
        );
      });
    });
  });
};
editDetails();



// WEBPACK FOOTER //
// ./src/js/_edit-details.js